import { ITranslationResource } from 'ngx-translate-multi-http-loader';

export const TRANSLATIONS_VERSION: string = '1.7.0';

export const TRANSLATIONS: ITranslationResource[] = [
  { prefix: `/translations/{{lang}}/antipattern.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/auth.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/dashboard.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/extension.`, suffix: '.json' },
  { prefix: `/translations/{{lang}}/student.`, suffix: '.json' },
];
